import { render } from "./ImgInfo.vue?vue&type=template&id=44859daa&scoped=true"
import script from "./ImgInfo.vue?vue&type=script&lang=js"
export * from "./ImgInfo.vue?vue&type=script&lang=js"

import "./ImgInfo.vue?vue&type=style&index=0&id=44859daa&lang=scss&scoped=true"

import exportComponent from "/opt/gitea/webhooker/hooks/dscontrol/kraken/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44859daa"]])

export default __exports__